                                                                                                                                    //CSS ENTRY POINT
//import '../scss/main.scss';
//=====================================
//jquery
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
//=====================================
window.$ = window.jQuery = require('jquery');
global.$ = global.jQuery = require('jquery');
window.App = window.App  || {};
window.comApp = window.comApp  || {};
//=====================================
//FANCY BOX
//=====================================
// import { Fancybox } from "@fancyapps/ui";
// window.Fancybox = Fancybox;
//=====================================
//Bootstrap
import * as bootstrap from 'bootstrap';
// // Or import only needed plugins
// import { Tooltip as Tooltip, Toast as Toast, Popover as Popover } from 'bootstrap';

// // Or import just one
// import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
//=====================================
// ※Facyboxをインポートすると圧縮版のnpmコンパイルで失敗するため
// webpack.config.jsのwebpack-fix-style-only-entriesを無効にした
//=====================================
// Popper
// require('@popperjs/core');
// require('bootstrap');
// import * as Popper from "@popperjs/core"
//=====================================
// JQUERYUI
//=====================================
// import 'jquery-ui/ui/widgets/draggable';


//=====================================
// window.Popper = require('@popperjs/core');
//=====================================
//Gsap
//=====================================
import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
window.gsap = gsap;

//=====================================
//SplitType
//=====================================
// const SplitType = require('split-type').default;
// window.SplitType = SplitType;
//=====================================
//Swiper
// import Swiper JS
// Swiper, Keyboard, Navigation, Pagination, Controller, History, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Lazy, A11y
//=====================================
const Swiper = require('swiper/bundle').default;
const { Navigation, Pagination, Autoplay, EffectFade, Scrollbar } = Swiper;
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Scrollbar]);
window.Swiper = Swiper;

//=====================================
//Muuri
//=====================================
// const Muuri = require('muuri').default;
// window.Muuri = Muuri;

//=====================================
//Swiper Slide 1
//=====================================
window.App.initializeSwiper = function(containerId, menuId, perView) {
  if (typeof perView !== 'number' || isNaN(perView)) {
    console.error('perView must be a number.');
    return;
  }
  var menuSwiper = new Swiper(menuId, {
    slidesPerView: perView,
    spaceBetween: 5,
    allowSlideNext: false,
    allowSlidePrev: false,
  });
  var mainSwiper = new Swiper(containerId, {
    loop: true,
    spaceBetween: 0,
    clickable: true,
    speed: 300,
    thumbs: {
      swiper: menuSwiper,
    },
  });
}


// =========================================
// Swiper Type A（coverflow系）
// .SwiperTypeA を自動取得して初期化
// =========================================
window.swiperTypeAInstances = window.swiperTypeAInstances || {};

window.createSwiperTypeA = function (selector) {
  if (!selector || selector.charAt(0) !== '#') {
    console.warn('createSwiperTypeA: selectorは#付きIDで指定してください');
    return;
  }

  var el = document.querySelector(selector);
  if (!el) return;

  if (window.swiperTypeAInstances[selector]) return;

  window.swiperTypeAInstances[selector] = new Swiper(selector, {
    effect: "coverflow",
    grabCursor: true,
    centeredSlides: true,
    slidesPerView: 1.4,
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 2.2,
      },
      960: {
        slidesPerView: 3.2,
      },
    },
  });
};

window.destroySwiperTypeA = function (selector) {
  if (!window.swiperTypeAInstances[selector]) return;

  window.swiperTypeAInstances[selector].destroy(true, true);
  delete window.swiperTypeAInstances[selector];
};

window.updateSwiperTypeA = function () {
  document.querySelectorAll('.SwiperTypeA').forEach(function (el) {
    if (!el.id) {
      console.warn('SwiperTypeAにはユニークなidを設定してください', el);
      return;
    }

    var selector = '#' + el.id;

    if (window.innerWidth <= 960) {
      window.createSwiperTypeA(selector);
    } else {
      window.destroySwiperTypeA(selector);
    }
  });
};


//=====================================
// JQUERY PAGE LOADED
//=====================================
$(function(){


// =========================================
// Swiper Type A 一括管理
// =========================================
window.updateSwiperTypeA();
var resizeTimerTypeA = false;
$(window).on('resize', function () {
  if (resizeTimerTypeA) {
    clearTimeout(resizeTimerTypeA);
  }
  resizeTimerTypeA = setTimeout(function () {
    window.updateSwiperTypeA();
  }, 200);
});


/* ==================
SECTION VISION PARALLAX + FADE + ZOOM
===================== */
gsap.utils.toArray('.section-vision--parallax').forEach(function(section) {
  const img = section.querySelector('.section-vision__media img');
  const texts = section.querySelectorAll(
    '.section-vision__sub, .section-vision__title, .section-vision__lead, .section-vision__action'
  );

  if (!img) return;

  // 画像：フェード + ズーム + パララックス
  gsap.fromTo(img,
    {
      opacity: 0,
      scale: 1.04,
      yPercent: -12
    },
    {
      opacity: 1,
      scale: 1.18,
      yPercent: 12,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 1
        // markers: true
      }
    }
  );

  // テキスト：少し遅れて出す
  if (texts.length) {
    gsap.fromTo(texts,
      {
        opacity: 0,
        y: 24
      },
      {
        opacity: 1,
        y: 0,
        duration: .8,
        stagger: .12,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: section,
          start: 'top 72%',
          once: true
        }
      }
    );
  }
});











// // .bar1要素のアニメーション
// $(".bar1").each(function(index, element) {
//   var width = $(element).width(); // バーの現在の幅を取得
//   var targetWidth = parseInt($(element).css("width")); // 目標の幅を取得
//   $(element).css("width", "0px");
//   gsap.to(element, {
//     scrollTrigger: {
//       trigger: element,
//       start: "top 80%", 
//       end: "bottom 20%",
//     },
//     width: targetWidth + "px",
//     duration: .5,
//     ease: "power2.inOut", 
//   });
// });

// $(".bar2").each(function(index, element) {
//   var height = $(element).height(); 
//   var targetHeight = parseInt($(element).css("height")); 
//   $(element).css("height", "0px");
//   gsap.to(element, {
//     scrollTrigger: {
//       trigger: element, 
//       start: "top 80%", 
//       end: "bottom 20%",
//     },
//     height: targetHeight + "px",
//     duration: .5,
//     ease: "power2.inOut", 
//   });
// });

//////////////////////////////
//カウントアップ
//////////////////////////////
$(".txt-num > i").each(function(index, element) {
  var $target = $(element);
  var targetText = $target.text();
  var targetNumber = parseInt(targetText, 10);
  var paddingLength = targetText.length; // 元の文字列の桁数を保持

  var duration = 800; // アニメーションの継続時間（ミリ秒）
  var currentNumber = 0; // 現在の数字

  function animateNumber() {
    $({ countNum: currentNumber }).animate({ countNum: targetNumber }, {
      duration: duration,
      easing: 'linear',
      step: function() {
        var value = Math.floor(this.countNum).toString().padStart(paddingLength, '0');
        $target.text(value);
        $target.addClass('animating').removeClass("animating_done"); 
      },
      complete: function() {
        var finalValue = targetNumber.toString().padStart(paddingLength, '0');
        $target.text(finalValue);
        $target.removeClass('animating').addClass("animating_done");
      }
    });
  }
  // カウントアップのアニメーションをスクロールトリガーとして設定
  gsap.to({}, {
    duration: 0.01,
    scrollTrigger: {
      trigger: $target.parent(), // 親要素をトリガーにする
      start: "top 80%", // スクロール位置でトリガー
      onEnter: animateNumber, // 要素がビューポートに入ったときにアニメーションを開始
      // markers: true // マーカーを表示（デバッグ用）
    }
  });
});

/* ==================
//FAQ ETC
===================== */
$(".lst-slidedown").find("li").on("click", function(){
  if ($(this).hasClass("shown")) {
    $(this).removeClass("shown");
  } else {
    $(this).addClass("shown");
  }
});


/* ==================
SIDE MENU
===================== */
// $('#glb_side_menu').on({
//   'mouseenter': function() {
//     $('body').addClass('is-sidemenu-hover');
//   },
//   'mouseleave': function() {
//     $('body').removeClass('is-sidemenu-hover');
//   }
// });
// var menuVisible = false; 
// var fixedVisible = false;
// $('#glb_side_menu').on('click', function() {
//   if (!menuVisible && !fixedVisible) { 
//       $('body').addClass('is_side_menu');
//       menuVisible = true; 
//   }
// });
// $('#wrapper-contents').on('mouseenter mouseover click touchend', function(e) {
//   $('body').removeClass('is_side_menu');
//   menuVisible = false; 
// });
// $('#global_burgermenu').on('click', function() {
//   if (!menuVisible) { 
//     $('body').addClass('is_side_menu');
//   menuVisible = true; 
//   }else{
//     $('body').removeClass('is_side_menu_fixed is_side_menu');
//     menuVisible = false;
//   }
// });

/////////////////////////////////////////////
//MODAL 
/////////////////////////////////////////////
// window.comApp.loadSection = function(source, modalId, modalTitle) {
//   if (source.startsWith('#')) {
//       // Copy content from the specified element
//       var content = $(source).html();
//       $("#ajx_content_output").html(content);
//       $(modalId).find('.modal-title').html(modalTitle);
//       $(modalId).modal('show');
//   } else {
//       // Load content from the specified URL
//       $.ajax({
//           type: 'GET',
//           url: source,
//           success: function(data) {
//               $("#ajx_content_output").html(data);
//               $(modalId).find('.modal-title').html(modalTitle);
//               $(modalId).modal('show');
//           }
//       });
//   }
// };

///////////////////////
//AJAX ZIP
// イベントハンドラを定義
///////////////////////
/*
function handleAjaxZip3() {
AjaxZip3.zip2addr('postal_code1', '', 'prefectures', 'address1');
// 成功時に実行する処理
AjaxZip3.onSuccess = function() {
    //  // 正しいIDを指定する必要があります
    // $('textarea[name="content"]').val('');
};
// 失敗時に実行する処理
AjaxZip3.onFailure = function() {
    alert('郵便番号に該当する住所が見つかりません');
    $('input[name="prefectures"]').val('');
    $('input[name="address1"]').val('');
    $('input[name="address2"]').val('');
};
}
// クリックイベントに対する処理
$('.ajaxzip3').on('click', function() {
  handleAjaxZip3();
  return false;
});

// Keyupイベントに対する処理
$('#postal_code1').on('keyup', function() {
  handleAjaxZip3();
});
*/

///////////////////////////////
/// TEXTAREA AUTOHEIGHT
/////////////////////////////////
// $('.js-autoheight').on('input', function(){
//   this.style.height = 'auto';
//   this.style.height = (this.scrollHeight) + 'px';
// });

////////////////////////
//FORM COPY
////////////////////////
/*
// モーダルが開かれる瞬間に発生するイベント
$('#Modal-form00').on('show.bs.modal', function () {
  $('body').removeClass('is_side_menu');
  var formAContent = $('#formA .fm-contact00').clone(true);
  $('#formB').empty().append(formAContent);
  $('#formA').empty();
});
// モーダルが閉じられる瞬間に発生するイベント
$('#Modal-form00').on('hidden.bs.modal', function () {
  var formBContent = $('#formB .fm-contact00').clone(true);
  $('#formA').empty().append(formBContent);
  $('#formB').empty();
});
*/ 
/////////////////////////
///AKAX POST
//////////////////////////

/*
$(document).on('click', '.submit-ajax', function(event) {
   // ◎ボタンを無効化
  $(this).prop('disabled', true);
  $(this).find("span").html('処理中...');

  var $myform = $(this).closest("form");
  var form_id = $myform.attr("id");
  var formToken = $myform.find('input[name="formToken"]').val()
  $.ajax({
    url: '/contact.php',
    type: 'post',
    data: $myform.serialize(),
    dataType: 'json',
    success: function(response) {
        $(".error").empty();
        console.log(response);

        // ◎ボタンを有効化
        $('.submit-ajax').prop('disabled', false);
        $('.submit-ajax').find("span").html('無料相談・現地調査・お見積り'); // 元のボタンのテキストに戻す

        if (response.errors) {
            var errors = response.errors;

            // 最初に表示されたエラーのIDにスクロール
            if (Object.keys(errors).length > 0) {
                var firstErrorKey = Object.keys(errors)[0];
                var firstErrorElement = $('#' + form_id + ' #error_' + firstErrorKey);  

                // エラーが非表示の場合、表示する
                firstErrorElement.show();

                // モーダル内であればモーダルのスクロール対象要素までスクロール
                if ($myform.find('.modal').length > 0) {
                    $('#' + form_id + ' .modal-body').animate({
                        scrollTop: firstErrorElement.offset().top - $('#' + form_id + ' .modal-body').offset().top + $('#' + form_id + ' .modal-body').scrollTop() - $('#' + form_id + ' .modal-header').height()
                    }, 500);
                } else {
                    // モーダル内でなければ通常のスクロール
                    var scrollOffset = firstErrorElement.offset().top - $(document).scrollTop() - 80;
                    $('html, body').animate({
                        scrollTop: '+=' + scrollOffset + 'px'
                    }, 500);
                }
            }
            for (var key in errors) {
                var errorSelector = '#error_' + key;
                $(errorSelector).html(errors[key]);
                console.log(errorSelector + "です");
            }
        } else if (response.success) {
          var redirectUrl = '/contact_done.php';
          var postData = {
              referrer: encodeURIComponent(window.location.href),
              token: formToken
          };

          // Create a hidden form dynamically
          var hiddenForm = $('<form>', {
              action: redirectUrl,
              method: 'post',
              style: 'display:none;'
          });

          // Add the necessary inputs (referrer and token)
          for (var key in postData) {
              hiddenForm.append($('<input>', {
                  type: 'hidden',
                  name: key,
                  value: postData[key]
              }));
          }
          // Append the form to the body and submit it
          $('body').append(hiddenForm);
          hiddenForm.submit();
          }
    },
    error: function(error) {
        // ◎エラー時もボタンを有効化
        $('.submit-ajax').prop('disabled', false);
        $('.submit-ajax').find("span").html('送信する'); // 元のボタンのテキストに戻す
        console.log('Error:', error);
    }
});
});
*/









/////////////////////////////////////////////
//HASH URL を削除
/////////////////////////////////////////////
setInterval(function() {
  if (window.location.hash) {
      history.replaceState(null, null, window.location.pathname + window.location.search);
  }
}, 10000); // 10秒ごとにチェック

/////////////////////////////////////////////
//TOOL TIPS (no HOVER but CLICK)
/////////////////////////////////////////////
// $('[data-bs-toggle="tooltip"]').tooltip();

/////////////////////////////////////////////
//MARQUEE #TEST 
/////////////////////////////////////////////
// class Marquee {
//   constructor() {
//     this.els = document.querySelectorAll('.marquee');
//     console.log(this.els);
//     if (!this.els) return;
//     this.init()
//   }
//   init() {
//     this.els.forEach(el => {
//       // 要素が非表示の場合は処理をスキップ
//       if (getComputedStyle(el).display === 'none') return;

//       const options = {
//         speed: el.dataset.marqueeSpeed || 60,
//         direction: el.dataset.marqueeDirection || 'left',
//         pauseOnHover: el.dataset.marqueeHover === 'true'
//       };
//       this.Marquee(el, options);
//     })
//   }
//   Marquee(el, options) {
//     const { speed, direction, pauseOnHover } = options;
//     const wrapper = el.querySelector('.marquee-wrapper');
//     const content = el.querySelector('.marquee-content');
//     this.appendContent(content, wrapper);
//     this.updateWrapperWidth(content, wrapper);
//     const animation = this.Animation(wrapper, speed, direction);

//     this.hoverEvent(el, animation, pauseOnHover);
//     this.observerEvent(el, animation);
//   }
//   updateWrapperWidth(content, wrap) {
//     const contentWidth = content.getBoundingClientRect().width;
//     console.log(contentWidth);
//     if (contentWidth === 0) return;
//     const gap = parseInt(getComputedStyle(content).columnGap);
//     wrap.style.width = `${contentWidth + gap}px`;
//   }
//   appendClone(content, wrap) {
//     const clone = content.cloneNode(true);
//     wrap.appendChild(clone);
//   }
//   appendContent(content, wrap) {
//     const innerWidth = window.innerWidth;
//     const contentWidth = content.getBoundingClientRect().width;

//     this.appendClone(content, wrap);

//     if (contentWidth < innerWidth) {
//       const numClones = Math.ceil(innerWidth / contentWidth);
//       for (let i = 0; i < numClones; i++) {
//         this.appendClone(content, wrap);
//       }
//     }
//   }
//   Animation(wrap, speed, direction) {
//     const wrapWidth = wrap.getBoundingClientRect().width;

//     if (wrapWidth === 0) return;
//     const keyframes = direction === 'left' ?
//       [{ translate: '0 0' }, { translate: '-100% 0' }] :
//       [{ translate: '-100% 0' }, { translate: '0 0' }];
//     const options = {
//       duration: (wrapWidth / speed) * 1000,
//       iterations: Infinity,
//     }
//     return wrap.animate(keyframes, options);
//   }
//   hoverEvent(el, animation, hasOpt) {
//     if (!hasOpt) return;
//     el.addEventListener('mouseenter', () => animation.pause());
//     el.addEventListener('mouseleave', () => animation.play());
//   }
//   observerEvent(el, animation) {
//     const observerOptions = {
//       root: null,
//       threshold: 0,
//     };

//     const observer = new IntersectionObserver((entry) => {
//       entry[0].isIntersecting ? animation.play() : animation.pause();
//     }, observerOptions);

//     observer.observe(el);
//   }
// }
// const marquee = new Marquee();



/////////////////////////////////////////////
//DEV
/////////////////////////////////////////////
// $(".dev-bg i").on("click", function(e) {
//   e.preventDefault();
//   var classNum = $(this).data("bg");
//   $(this).closest(".mvimg").removeClass(function(index, className) {
//   return (className.match(/(^|\s)mv-\S+/g) || []).join(" ");
//   }).addClass("mv-" + classNum);
//   });
  
//   $('[data-js="add_hover"]').hover(function() {
//   $(this).closest('.mvimg').addClass('is_hover');
//   }, function() {
//   $(this).closest('.mvimg').removeClass('is_hover');
//   });
// $('[data-js="add_hover"]').hover(function() {
// $(this).closest('.mvimg').addClass('is_hover');
// }, function() {
// $(this).closest('.mvimg').removeClass('is_hover');
// });

//KILL TARGET
//   $(".kill").on("click", function() {
//     if (confirm("本当に削除しますか？")) {
//         $(this).closest(".targetkill").hide();
//     }
//   });




});
